import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Full-screen "generating" screen.
 * Extracted verbatim from pages/Articles/CreateArticle.js.
 */
export default function GeneratingOverlay() {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto text-center">
        {/* Generating Icon */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-6">
          <svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>

        {/* Generating Message */}
        <h2 className="text-4xl font-medium text-gray-900 mb-4">
          {t('articles.create.generating.title')}
        </h2>
        <p className="text-gray-600 mb-8 text-lg">
          {t('articles.create.generating.description')}
        </p>

        <div className="text-sm text-gray-500">
          {t('articles.create.generating.warning')}
        </div>
      </div>
    </div>
  );
}
